export default __webpack_public_path__ + "images/77e7cb9d28185f175ba2720ca0a23df3-fineart_small.webp";